import { render, staticRenderFns } from "./BOMProgress.vue?vue&type=template&id=2c7342d5&scoped=true&"
import script from "./BOMProgress.vue?vue&type=script&lang=js&"
export * from "./BOMProgress.vue?vue&type=script&lang=js&"
import style0 from "./BOMProgress.vue?vue&type=style&index=0&id=2c7342d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7342d5",
  null
  
)

export default component.exports